import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import Layout from "../components/layout.js"
import SEO from "../components/seo"
import Form from "../components/form"

export const query = graphql`
  query($id: ID!) {
    wpgraphql {
      pageBy(id: $id) {
        title(format: RENDERED)
        content(format: RENDERED)
        pageACF {
          showContactForm
        }
        featuredImage {
          node {
            title(format: RENDERED)
            sourceUrl
            imageFile {
              childImageSharp {
                fluid(maxWidth: 1140, maxHeight: 500) {
                  ...GatsbyImageSharpFluid
                }
                resize(width: 900, quality: 90) {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`
const PageTemplate = ({ data }) => {
  const { title, content, featuredImage, pageACF } = data.wpgraphql.pageBy

  const featured =
    featuredImage && featuredImage !== null ? (
      <div className="flex-container mb-2">
        <Img
          fixed={featuredImage.node.imageFile.childImageSharp.fluid}
          objectFit="cover"
          objectPosition="50% 50%"
          alt={featuredImage.node.title}
        />
      </div>
    ) : null

  const metaFeatured =
    featuredImage && featuredImage !== null
      ? featuredImage.node.imageFile.childImageSharp.resize.src
      : null

  const form =
    pageACF.showContactForm === true ? (
      <div className="mb-2">
        <Form />
      </div>
    ) : null
  return (
    <Layout>
      <SEO title={`Mes plats du jour | ${title}`} metaFeatured={metaFeatured} />
      <div className="grid-container">
        <h1 className="text-center mt-2 mb-2">{title}</h1>
        {featured}
        <section className="section section--small">
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        </section>
        {form}
      </div>
    </Layout>
  )
}

export default PageTemplate
